import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonRectComponent } from './skeleton-rect/skeleton-rect.component';
import { SkeletonDirective } from './skeleton.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [SkeletonRectComponent, SkeletonDirective],
  exports: [SkeletonRectComponent, SkeletonDirective]
})
export class SkeletonModule {}
